package pl.mothdigital.neuronowi.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import pl.mothdigital.neuronowi.common.utils.fixPolishOrphans
import pl.mothdigital.neuronowi.components.text.*
import pl.mothdigital.neuronowi.theme.*

@Composable
fun SpecialistInfoCard(
    icon: @Composable () -> Unit,
    title: String,
    description: String,
    modifier: Modifier = Modifier
) {
    Box(
        modifier = modifier
            .backgroundColor(SiteTheme.green._50)
            .padding(1.5.cssRem)
            .borderRadius(0.75.cssRem)
            .boxShadow(blurRadius = 4.px, color = rgba(0, 0, 0, 0.1))
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().gap(1.cssRem),
            horizontalAlignment = Alignment.Start
        ) {
            Row(
                modifier = Modifier.fillMaxWidth().gap(1.cssRem),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Div(
                    attrs = Modifier
                        .backgroundColor(SiteTheme.green._100)
                        .color(SiteTheme.green._800)
                        .fontSize(1.5.cssRem)
                        .padding(0.75.cssRem)
                        .borderRadius(50.percent)
                        .toAttrs()
                ) {
                    icon()
                }
                
                AppH3(modifier = Modifier.margin(0.px)) { Text(title.fixPolishOrphans()) }
            }
            
            AppP(modifier = Modifier.margin(0.px).textAlign(TextAlign.Justify)) { Text(description.fixPolishOrphans()) }
        }
    }
}
